export const GET_SOCIAL_LIST_DATA = 'GET_SOCIAL_LIST_DATA'
export const SET_SOCIAL_LOADING = 'SET_SOCIAL_LOADING'
export const CLEAR_SOCIAL = 'CLEAR_SOCIAL'
